module.exports = __webpack_public_path__ + "img/icon1.cc61f3f8.png";